module.exports = __webpack_public_path__ + "static/media/processDone.cf99bff7.png";